import { render, staticRenderFns } from "./contract-hhxm-detaili.vue?vue&type=template&id=f10c5572&scoped=true"
import script from "./contract-hhxm-detaili.vue?vue&type=script&lang=js"
export * from "./contract-hhxm-detaili.vue?vue&type=script&lang=js"
import style0 from "./contract-hhxm-detaili.vue?vue&type=style&index=0&id=f10c5572&prod&lang=css"
import style1 from "./contract-hhxm-detaili.vue?vue&type=style&index=1&id=f10c5572&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10c5572",
  null
  
)

export default component.exports